import React from 'react';
import { Link } from 'react-router-dom';
import { PawPrint, ChevronRight } from 'lucide-react';

const PageHeader = ({ title, breadcrumbs = [] }) => {
  return (
    <section className="relative bg-gradient-to-br from-[#f3d6f5] via-[#fdf3fc] to-[#f9e0fa] py-20 lg:py-28 overflow-hidden">
      <PawPrint className="absolute top-10 right-10 w-32 h-32 text-white/40 rotate-12" />
      <PawPrint className="absolute bottom-10 left-10 w-24 h-24 text-white/40 -rotate-12" />
      <div className="max-w-[1280px] mx-auto px-5 lg:px-10 text-center relative">
        <h1 className="font-serif text-[44px] lg:text-[68px] font-extrabold text-[#1a0b3d] mb-4">
          {title}
        </h1>
        <nav className="flex items-center justify-center gap-2 text-[14px] text-slate-600">
          <Link to="/" className="hover:text-[#5b3eb5]">Home</Link>
          {breadcrumbs.map((b, i) => (
            <React.Fragment key={i}>
              <ChevronRight size={14} />
              {b.path ? (
                <Link to={b.path} className="hover:text-[#5b3eb5]">{b.label}</Link>
              ) : (
                <span className="text-[#5b3eb5] font-semibold">{b.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
      </div>
    </section>
  );
};

export default PageHeader;
